import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import big_api_icon from '../../../assets/images/content/api-icon.png';
import big_apple_icon from '../../../assets/images/content/apple-icon.png';
import AppleIcon16pxSvg from '../../../assets/images/icons/AppleIcon16pxSvg';
import CircleXIcon14pxSvg from '../../../assets/images/icons/CircleXIcon14pxSvg';
import CPUIconGreen20pxSvg from '../../../assets/images/icons/CPUIconGreen20pxSvg';
import PlugIcon14pxSvg from '../../../assets/images/icons/PlugIcon14pxSvg';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import SettingIcon14pxSvg from '../../../assets/images/icons/SettingIcon14pxSvg';
import DefaultTooltip from '../../../components/DefaultTooltip';
import PrimaryDivider from '../../../components/PrimaryDivider';
import { StyledLinkBlue } from '../../../components/StyledLink';
import UnregisterDeviceDialog from '../UserManagement/UnregisterDeviceDialog';
import EditIconGreen14pxSvg from './../../../assets/images/icons/EditIconGreen14pxSvg';
import RecycleIconBlue14pxSvg from './../../../assets/images/icons/RecycleIconBlue14pxSvg';
import {
   ControlpanelErrorButton,
   ControlpanelInfo2thButton,
   ControlpanelPrimaryButton,
   ControlpanelSecondary2thButton,
   ControlpanelSuccess2thButton,
} from './../../../components/StyledButton';
import DeviceSpecificSettingsDialog from './DeviceSpecificSettingsDialog';
import EditApiAccessDialog from './EditApiAccessDialog';
import EditDeviceDialog from './EditDeviceDialog';
import GenerateANewDeviceRegistrationTokenDialog from './GenerateANewDeviceRegistrationTokenDialog';
import DeviceApi from '../../../axios/Device/DeviceApi';
import { getDeviceByUser } from '../../../axios/User/UserApi';

const DevicesInfo = (props) => {
   const { t, i18n } = useTranslation();
   const { info, usersData, GroupData, refreshData, onRefresh } = props;
   const currentLang = i18n.language;
   const [openReRegisterDevice, setOpenReRegisterDevice] = useState(false);
   const [activeStatus, setActiveStatus] = useState();
   const [deviceDetail, setDeviceDetail] = useState([]);
   const [deviceMobileDetail, setDeviceMobileDetail] = useState([]);
   const { getDeviceDetail } = DeviceApi();

   useEffect(() => {
      if (!info?.id) return;
      
      const fetchDetail = async () => {
         try {
            if (info?.deviceType === 'MOBILE') {
               const response = await getDeviceByUser({ id: info?.id });
               setDeviceMobileDetail(response?.data?.data?.[0]);
            } else {
               const res = await getDeviceDetail(
                  { id: info?.id },
                  localStorage.getItem("i18nextLngId")
               );
               setDeviceDetail(res.data.data || res.data);
            }
         } catch (err) {
            console.error("Error fetch device detail:", err);
         }
      };

      fetchDetail();
   }, [info?.id]);

   const handleOpenReRegisterDevice = () => {
      setActiveStatus('group');
      setOpenReRegisterDevice(true);
   };

   const handleCloseReRegisterDevice = () => {
      setOpenReRegisterDevice(false);
   };

   const displayButtonData = [
      {
         icon: <EditIconGreen14pxSvg />,
         title: t('button.edit'),
         type: 'edit',
         // onClick: info?.application !== 'Third party API client' ? () => handleOpenEditDevice(info) : () => handleOpenEditApiAccess(info),
      },
      {
         icon: <RecycleIconBlue14pxSvg className='fill-white' />,
         title: t('button.re-register'),
         type: 'reRegister',
         onClick: handleOpenReRegisterDevice,
      },
      { icon: <CircleXIcon14pxSvg />, title: t('button.block'), type: 'block', onClick: null },
      { icon: <PlugIcon14pxSvg />, title: t('button.unregister'), type: 'unregister', onClick: () => handleOpenUnregisterDevice() },
      { icon: <SettingIcon14pxSvg />, title: t('button.settings'), type: 'setting', onClick: () => handleOpenDeviceSpecificSettings(info) },
   ];

   const renderButton = (button) => {
      switch (button.type) {
         case 'edit':
            return (
               <ControlpanelSuccess2thButton className="pointer-events-none opacity-50">
                  {button.icon}
                  {button.title}
               </ControlpanelSuccess2thButton>
            );
         case 'reRegister':
            return (
               <ControlpanelInfo2thButton className="pointer-events-none opacity-50">
                  {button.icon}
                  {button.title}
               </ControlpanelInfo2thButton>
            );
         case 'block':
            return (
               <ControlpanelSecondary2thButton className="pointer-events-none opacity-50">
                  {button.icon}
                  {button.title}
               </ControlpanelSecondary2thButton>
            );
         case 'unregister': {
            const hasDevice = Boolean(info?.id);
            return (
               <ControlpanelErrorButton
                  className={hasDevice ? 'pointer-events-auto' : 'pointer-events-none opacity-50'}
                  onClick={hasDevice ? button.onClick : undefined}
               >
                  {button.icon}
                  {button.title}
               </ControlpanelErrorButton>
            );
         }
         case 'setting':
            return (
               <ControlpanelPrimaryButton className="pointer-events-none opacity-50">
                  {button.icon}
                  {button.title}
               </ControlpanelPrimaryButton>
            );
         default:
            return null;
      }
   };


   const filteredThirdPartyButtonData = displayButtonData.filter((button) => button.type !== 'reRegister' && button.type !== 'setting');

   const [openUnregisterDevice, setOpenUnregisterDevice] = useState(false);
   const [selectedDeviceName, setSelectedDeviceName] = useState({});
   const handleOpenUnregisterDevice = () => {
      setOpenUnregisterDevice(true);
   };

   const handleCloseUnregisterDevice = () => {
      setOpenUnregisterDevice(false);
   };

   const [openDeviceSpecificSettings, setOpenDeviceSpecificSettings] = useState(false);

   const handleOpenDeviceSpecificSettings = (divice) => {
      setSelectedDeviceName(divice);
      setOpenDeviceSpecificSettings(true);
   };

   const handleCloseDeviceSpecificSettings = () => {
      setOpenDeviceSpecificSettings(false);
   };

   const [openEditDevice, setOpenEditDevice] = useState(false);

   const handleOpenEditDevice = (divice) => {
      setSelectedDeviceName(divice);
      setOpenEditDevice(true);
   };

   const handleCloseEditDevice = () => {
      setOpenEditDevice(false);
   };

   const [openEditApiAccess, setOpenEditApiAccess] = useState(false);

   const handleOpenEditApiAccess = (divice) => {
      setSelectedDeviceName(divice);
      setOpenEditApiAccess(true);
   };

   const handleCloseEditApiAccess = () => {
      setOpenEditApiAccess(false);
   };

   return (
      <div className='card px-3 py-3 flex flex-col h-full'>
         <div className='flex items-center justify-between'>
            <div className='flex gap-1 items-center'>
               <p className='text-xl font-semibold'>{info?.description}</p>
               <div className='grey-chip'>{info?.blocked === true ? t('common.blocked') : t('common.unblocked')}</div>
               <DefaultTooltip
                  readMore={true}
                  title={t('tool-tip.device-api-quick-view')}
                  content={
                     <div className='flex flex-col gap-3'>
                        <p>{t('tool-tip.this-view-shows-available-details-and-operations')}.</p>
                     </div>
                  }
               >
                  <QuestionIcon16pxSvg className='fill-[#BDBDBD]' />
               </DefaultTooltip>
            </div>
            {/* <p className='text-xl'>
               <span className='font-bold text-[#14B8A6]'>{t('common.last-access')}:</span> 7 hours ago
            </p> */}
         </div>
         <div className='my-3'>
            <PrimaryDivider />
         </div>
         {info?.application !== 'Third party API client' ? (
            <div className='not-third-party flex flex-col flex-1'>
               <div className='flex justify-between flex-1'>
                  {info?.deviceType === 'MOBILE' ? (<div className='flex flex-col gap-3 flex-grow'>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.device-sn')}:</p>
                        </div>
                        <div className='col-span-3 sm:col-span-2 flex flex-col gap-1'>
                           <p>{deviceMobileDetail?.deviceUUID}</p>
                        </div>
                     </div>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.device-name')}:</p>
                        </div>
                        <div className='col-span-3 sm:col-span-2 flex flex-col gap-1'>
                           <p>{deviceMobileDetail?.deviceName}</p>
                        </div>
                     </div>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.os-name')}:</p>
                        </div>
                        <div className='col-span-2 flex flex-col gap-1'>
                           <p>{deviceMobileDetail?.deviceOS}</p>
                        </div>
                     </div>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.content-125')}:</p>
                        </div>
                        <div className='col-span-2 flex flex-col gap-1'>
                           <p>{info?.fullName}</p>
                        </div>
                     </div>
                  </div>) : (
                  <div className='flex flex-col gap-3 flex-grow'>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.device-sn')}:</p>
                        </div>
                        <div className='col-span-3 sm:col-span-2 flex flex-col gap-1'>
                           <p>{deviceDetail[0]?.deviceSN}</p>
                        </div>
                     </div>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.brand')}:</p>
                        </div>
                        <div className='col-span-3 sm:col-span-2 flex flex-col gap-1'>
                           <p>{deviceDetail[0]?.brand}</p>
                        </div>
                     </div>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.port')}:</p>
                        </div>
                        <div className='col-span-2 flex flex-col gap-1'>
                           <p>{deviceDetail[0]?.port}</p>
                        </div>
                     </div>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.content-117')}:</p>
                        </div>
                        <div className='col-span-2 flex flex-col gap-1'>
                           <p>{deviceDetail[0]?.description}</p>
                        </div>
                     </div>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.assigned-for')}:</p>
                        </div>
                        <div className='col-span-2 flex flex-col gap-1'>
                           {deviceDetail[0]?.userId ? (
                              `${deviceDetail[0]?.fullName}`
                              // currentLang === 'vi'
                              //    ? `${info?.lastName} ${info?.firtName}`
                              //    : `${info?.firtName} ${info?.lastName}`
                           ) : deviceDetail[0]?.groupId ? (
                              GroupData?.find((group) => group.id === deviceDetail[0]?.groupId)?.groupName || t('common.no-assignee')
                           ) : (
                              t('common.no-assignee')
                           )}
                        </div>
                     </div>
                     <div className='grid grid-cols-3'>
                        <div className='col-span-3 sm:col-span-1 flex items-center gap-1'>
                           {/* <AppleIcon16pxSvg /> */}
                           <p className='font-semibold capitalize'>{t('common.company-name')}:</p>
                        </div>
                        <div className='col-span-2 flex flex-col gap-1'>
                           <p>{deviceDetail[0]?.companyName}</p>
                        </div>
                     </div>
                  </div>)}
               </div>
               <div className='h-[1px] bg-[#E7E7E7] w-full my-3 mt-auto'></div>
               <div className='flex flex-wrap gap-2 justify-end'>
                  {displayButtonData.map((button, index) => (
                     <div key={index}>{renderButton(button)}</div>
                  ))}
               </div>
            </div>
         ) : (
            <div className='third-party flex flex-col flex-1'>
               <div className='flex justify-between flex-1'>
                  <div className='flex flex-col gap-3 flex-grow'>
                     <div className='flex gap-3 items-center'>
                        <div>
                           <CPUIconGreen20pxSvg />
                        </div>
                        <div>
                           <p className='text-[#14B8A6] font-semibold text-base'>
                              {t('common.this-is-a-third-party-application-created-to-access')}
                           </p>
                           <p className='text-[#6B7280]'>API access permission: Read only (Auditor)</p>
                        </div>
                     </div>
                     <div className='border border-[#E5E7EB] rounded-md p-4 flex flex-col gap-1'>
                        <p>
                           {t('common.userName')}: <span className='font-semibold text-[#EF4444]'>{info?.userName}</span>
                        </p>
                        <p>
                           {t('common.password')}: <StyledLinkBlue className='!font-semibold cursor-pointer'>Change</StyledLinkBlue>
                        </p>
                     </div>
                     <p>
                        {t('common.to-learn-how-this-can-be-integrate-with-your-system')},
                        <StyledLinkBlue className='cursor-pointer'>{t('common.read the API document')}</StyledLinkBlue>
                     </p>
                  </div>
                  <div className='max-w-32 hidden md:block'>
                     <img src={big_api_icon} alt='icon' />
                  </div>
               </div>
               <div className='h-[1px] bg-[#E7E7E7] w-full my-3 mt-auto'></div>
               <div className='flex flex-wrap gap-2 justify-end'>
                  {filteredThirdPartyButtonData.map((button, index) => (
                     <div key={index}>{renderButton(button)}</div>
                  ))}
               </div>
            </div>
         )}
         {openUnregisterDevice && <UnregisterDeviceDialog onClose={handleCloseUnregisterDevice} infoDevice={deviceMobileDetail} onRefresh={onRefresh} />}
         <DeviceSpecificSettingsDialog
            open={openDeviceSpecificSettings}
            handleClose={handleCloseDeviceSpecificSettings}
            selectedDeviceName={selectedDeviceName}
         />
         <GenerateANewDeviceRegistrationTokenDialog
            open={openReRegisterDevice}
            handleClose={handleCloseReRegisterDevice}
            activeStatus={activeStatus}
            usersData={usersData}
         />
         <EditDeviceDialog open={openEditDevice} handleClose={handleCloseEditDevice} info={selectedDeviceName} />
         <EditApiAccessDialog open={openEditApiAccess} handleClose={handleCloseEditApiAccess} info={selectedDeviceName} />
      </div>
   );
};

export default DevicesInfo;
